"use strict";
/* eslint-disable functional/prefer-readonly-type */
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePromotionPropertiesSchemaByPromotionTypeAndItsSettingsSchema = exports.PromotionSettingsSchema = exports.BasePromotionPropertiesSchema = exports.PromotionCriteriaSchema = exports.PromotionThresholdSchema = exports.PromotionPriceThresholdSchema = exports.PromotionAmountThresholdSchema = exports.PromotionDiscountSchema = exports.PromotionPercentageDiscountSchema = exports.PromotionFixedDiscountSchema = exports.PromotionAmountDiscountSchema = exports.FreeProductSchema = exports.IDSchema = exports.flattenZodValidationError = exports.OptionalAndNullishSchema = exports.isValueMatchedSchema = void 0;
const zod_1 = require("zod");
const typings_1 = require("../../typings");
// #region Utility functions
const isValueMatchedSchema = (schema, matchedValue) => schema.refine((val) => val === matchedValue);
exports.isValueMatchedSchema = isValueMatchedSchema;
const OptionalAndNullishSchema = (schema) => schema.optional().nullish();
exports.OptionalAndNullishSchema = OptionalAndNullishSchema;
const flattenZodValidationError = (issue) => ({
    message: issue.message,
    errCode: issue.code,
    path: issue.path,
});
exports.flattenZodValidationError = flattenZodValidationError;
// #endregion
exports.IDSchema = zod_1.z.union([zod_1.z.string(), zod_1.z.number()]);
exports.FreeProductSchema = zod_1.z.object({
    id: exports.IDSchema,
    amount: (0, exports.OptionalAndNullishSchema)(zod_1.z.number().positive()),
    stock: (0, exports.OptionalAndNullishSchema)(zod_1.z.number()),
    weight: (0, exports.OptionalAndNullishSchema)(zod_1.z.number()),
});
// #region Promotion discount
exports.PromotionAmountDiscountSchema = zod_1.z.object({
    amount: zod_1.z.number(),
});
exports.PromotionFixedDiscountSchema = zod_1.z.object({
    fixed: zod_1.z.number(),
});
exports.PromotionPercentageDiscountSchema = zod_1.z.object({
    percent: zod_1.z.number(),
});
exports.PromotionDiscountSchema = zod_1.z.union([
    exports.PromotionAmountDiscountSchema,
    exports.PromotionFixedDiscountSchema,
    exports.PromotionPercentageDiscountSchema,
]);
// #endregion
// #region Promotion threshold
exports.PromotionAmountThresholdSchema = zod_1.z.object({
    amount: zod_1.z.number(),
});
exports.PromotionPriceThresholdSchema = zod_1.z.object({
    price: zod_1.z.number(),
});
exports.PromotionThresholdSchema = zod_1.z.union([exports.PromotionAmountThresholdSchema, exports.PromotionPriceThresholdSchema]);
// #endregion
exports.PromotionCriteriaSchema = zod_1.z.object({
    operator: (0, exports.OptionalAndNullishSchema)(zod_1.z.nativeEnum(typings_1.PromotionOperator)),
    thresholds: (0, exports.OptionalAndNullishSchema)(zod_1.z.array(exports.PromotionThresholdSchema)),
    discount: (0, exports.OptionalAndNullishSchema)(exports.PromotionDiscountSchema),
    freeProducts: (0, exports.OptionalAndNullishSchema)(zod_1.z.array(exports.FreeProductSchema)),
    minimumThreshold: (0, exports.OptionalAndNullishSchema)(zod_1.z.number()),
    maximumThreshold: (0, exports.OptionalAndNullishSchema)(zod_1.z.number()),
});
exports.BasePromotionPropertiesSchema = zod_1.z.object({
    id: (0, exports.OptionalAndNullishSchema)(exports.IDSchema),
    name: zod_1.z.string(),
    shortName: zod_1.z.string(),
    type: zod_1.z.nativeEnum(typings_1.PromotionType),
    priority: (0, exports.OptionalAndNullishSchema)(zod_1.z.number()),
    remainingAmount: (0, exports.OptionalAndNullishSchema)(zod_1.z.number()),
    remainingPrice: (0, exports.OptionalAndNullishSchema)(zod_1.z.number()),
    remainingProductSKUId: (0, exports.OptionalAndNullishSchema)(exports.IDSchema),
    upSellingDiscount: (0, exports.OptionalAndNullishSchema)(zod_1.z.number()),
    upSellingFreeProducts: (0, exports.OptionalAndNullishSchema)(zod_1.z.array(exports.FreeProductSchema)),
    upSellingThreshold: (0, exports.OptionalAndNullishSchema)(zod_1.z.number()),
});
exports.PromotionSettingsSchema = zod_1.z.object({
    awardFromLowToHigh: (0, exports.OptionalAndNullishSchema)(zod_1.z.boolean()),
    condition: zod_1.z.nativeEnum(typings_1.PromotionCondition),
    criteria: (0, exports.OptionalAndNullishSchema)(zod_1.z.array(exports.PromotionCriteriaSchema)),
    isBundled: zod_1.z.boolean(),
    type: zod_1.z.nativeEnum(typings_1.PromotionSettingsType),
});
const generatePromotionPropertiesSchemaByPromotionTypeAndItsSettingsSchema = (promotionType, promotionSettingsSchema) => exports.BasePromotionPropertiesSchema.extend({
    type: (0, exports.isValueMatchedSchema)(zod_1.z.string(), promotionType),
    settings: promotionSettingsSchema,
});
exports.generatePromotionPropertiesSchemaByPromotionTypeAndItsSettingsSchema = generatePromotionPropertiesSchemaByPromotionTypeAndItsSettingsSchema;
//# sourceMappingURL=base.js.map